// Angular
import { AfterViewInit, Component, HostBinding, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

// RxJS
import { filter } from 'rxjs/operators';
// Translate
import { TranslationService } from '../../../../../core/_base/layout';
import { CommonService } from '../../../../../Service/common/common-service.service';
import {environment} from '../../../../../../environments/environment';
import {Ba1010Class} from '../../../../../Class/ba1010/ba1010-class';

@Component({
	selector: 'kt-notification',
	templateUrl: './notification.component.html',
	styleUrls: ['notification.component.scss']
})
export class NotificationComponent {

	lblCompanyName: string;
	private CompanyList: Array<Ba1010Class> = [];

	// Show dot on top of the icon
	@Input() dot: string;

	// Show pulse on icon
	@Input() pulse: boolean;

	@Input() pulseLight: boolean;

	// Set icon class name
	@Input() icon = 'flaticon2-bell-alarm-symbol';
	@Input() iconType: '' | 'success';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' = 'light';

	@Input() type: 'brand' | 'success' = 'success';

	searchText: string = '';
   CompanyListBackup: any[] = [];

	/**
	 * Component constructor  
	 *
	 * @param sanitizer: DomSanitizer
	 */
	constructor(private sanitizer: DomSanitizer, private objCommonService:CommonService, private changeDetectorRef: ChangeDetectorRef) {
	}

	ngOnInit() {
		this.CompanyList=[];
		this.CompanyList.splice(0);
		this.GetCompanyWithPermission();
	}

	ngAfterViewInit(): void {

	}

	GetCompanyWithPermission()
	{
	  this.objCommonService.GetCompanyWithPermission().subscribe(data=>{
		var objBa1010Class = new Ba1010Class();

		if( data.length == 0)
		{
			document.getElementById('MainDivComp').style.display = 'none';
		}
		else if( data.length == 1)
		{ 
			document.getElementById('ngbMeniList').style.display = 'none';
		}
		else
		{
			document.getElementById('ngbMeniList').style.display = 'block';
		}

		for(var i=0; i<= data.length-1; i++)
		{
			if(data[i].RecStatus == 1)
			{
				this.lblCompanyName = data[i].CompCod + ' - ' + data[i].CompNam;
			}
			else
			{
				objBa1010Class = new Ba1010Class();
				objBa1010Class.CompId = data[i].CompId;
				objBa1010Class.CompCod = data[i].CompCod;
				objBa1010Class.CompNam = data[i].CompNam;
				this.CompanyList.push(objBa1010Class);
				this.CompanyListBackup.push(objBa1010Class);
			}
		}
		// this.CompanyList = data;
	    this.changeDetectorRef.detectChanges();
	  })
	}

	ChangeCompany(CompId)
	{
		this.objCommonService.ChangeCompany(CompId).subscribe(data=>{
			localStorage.clear();
			localStorage.setItem('currentUser', JSON.stringify(data));
			localStorage.setItem('LanguageId', JSON.stringify(data.LanguageId));
			localStorage.setItem('PortalUser', JSON.stringify(data.PortalUser));
			//window.location.href='/#/dashboard';
			//window.location.reload();
			//window.location.href='/dashboard'; 
			window.location.href='/#/widget/widget-dashboard/3';
			window.location.reload();
		})
	}
	
	backGroundStyle(): string {
		if (!this.bgImage) {
			return 'none';
		}

		return 'url(' + this.bgImage + ')';
	}
	filterCompany() {
  const text = this.searchText.toLowerCase();

  this.CompanyList = this.CompanyListBackup.filter(x =>
    (x.CompCod + ' ' + x.CompNam).toLowerCase().includes(text)
  );
   this.changeDetectorRef.detectChanges();
}
}
